// extracted by mini-css-extract-plugin
export default {"fileView":"FileView_fileView__Vk2QK","fileSize":"FileView_fileSize__2UZWs","fileName":"FileView_fileName__nj0DG"};